import { type PolymorphicComponent } from '@mui/base'
import { clsx } from 'clsx'
import { type ElementType, type ReactNode } from 'react'

import { Skeleton } from 'base-ui'

import { useCrossSellWidgetContext } from '../CrossSellWidgetProvider'

type CrossSellHorizontalSliderWidgetTitleOwnProps = {
  children?: ReactNode
  slots?: {
    root?: ElementType
  }
}

interface CrossSellHorizontalSliderWidgetTitleTypeMap<
  RootComponentType extends ElementType = 'h2',
> {
  defaultComponent: RootComponentType
  props: CrossSellHorizontalSliderWidgetTitleOwnProps
}

export const CrossSellWidgetTitle: PolymorphicComponent<
  CrossSellHorizontalSliderWidgetTitleTypeMap
> = ({ children, slots, ...restProps }) => {
  const { widgetTitle } = useCrossSellWidgetContext()
  const Root = slots?.root ?? 'h2'
  const title = widgetTitle ?? children

  if (!title) {
    return (
      <Skeleton
        className={clsx(
          'cross-sell-widget-title_skeleton',
          restProps.className,
        )}
        {...restProps}
      />
    )
  }

  return <Root {...restProps}>{title}</Root>
}
